<app-page-container width="narrow" [navbar]="false">
  <div *transloco="let t" class="mx-auto max-w-md py-12 sm:py-16">
    <a routerLink="/" class="mx-auto mb-4 block w-max">
      <img src="/assets/images/logo.png" alt="Edutrip" class="h-20 w-40 object-contain" />
    </a>

    <div class="rounded-[20px] border border-slate-200 bg-white p-7 shadow-sm sm:p-10">
      <!-- Title -->
      <h1 class="text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">
        {{ t('login.title') }}
      </h1>

      <!-- Subtitle -->
      <p class="mt-2 text-sm text-slate-600">{{ t('login.subtitle') }}</p>

      <!-- Login Form -->
      <form [formGroup]="form" (ngSubmit)="submit()" class="mt-6 space-y-4">
        <div>
          <label for="email" class="block text-sm font-medium text-slate-700">
            {{ t('login.email') }}
          </label>
          <input
            id="email"
            type="email"
            formControlName="email"
            autocomplete="email"
            class="mt-1 block w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-sm text-slate-900 transition-colors placeholder:text-slate-400 focus:border-accent-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-accent-100"
            [class.border-red-400]="form.controls.email.touched && form.controls.email.invalid"
          />
          @if (form.controls.email.touched && form.controls.email.invalid) {
            <p class="mt-1 text-xs text-red-600">{{ t('login.emailInvalid') }}</p>
          }
        </div>

        <div>
          <div class="flex items-baseline justify-between gap-3">
            <label for="password" class="block text-sm font-medium text-slate-700">
              {{ t('login.password') }}
            </label>
            <a
              routerLink="/forgot-password"
              class="text-xs font-medium text-accent-600 transition-colors hover:text-accent-700"
            >
              {{ t('login.forgotPassword') }}
            </a>
          </div>
          <input
            id="password"
            type="password"
            formControlName="password"
            autocomplete="current-password"
            class="mt-1 block w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 text-sm text-slate-900 transition-colors placeholder:text-slate-400 focus:border-accent-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-accent-100"
            [class.border-red-400]="form.controls.password.touched && form.controls.password.invalid"
          />
          @if (form.controls.password.touched && form.controls.password.invalid) {
            <p class="mt-1 text-xs text-red-600">{{ t('login.passwordRequired') }}</p>
          }
        </div>

        @if (error()) {
          <p class="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{{ error() }}</p>
        }

        <button appButton type="submit" class="w-full" [disabled]="auth.loading()">
          {{ auth.loading() ? t('login.submitting') : t('login.submit') }}
        </button>
      </form>
    </div>

    <!-- Back To Home-->
    <a
      routerLink="/"
      class="mt-6 block text-center text-sm font-medium text-slate-600 transition-colors hover:text-accent-600"
    >
      {{ t('login.backHome') }}
    </a>
  </div>
</app-page-container>
